// 设备信息
export const CHECK_DEVICE = 'SET_DEVICE'

// 配置部分

// 大会组件配置
export const SET_COMPONENTS_CONFIG = 'SET_COMPONENTS_CONFIG'
// 大会核心信息 - 年份/地方/会别
export const SET_CON_KEYINFO = 'SET_CON_KEYINFO'

// 大会核心数据
export const PARSE_CON_DATA = 'PARSE_CON_DATA'

// 设置 speaker 类型映射
export const SET_SPEAKERS_MAP = 'SET_SPEAKERS_MAP'
